<template>
  <div class="buttonlist">
    <div class="buttonlist-m" style="max-width:640px">
      <div class="page-tip">新建护理组并指定组长、初始成员（PRD 护理组增加）</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="组名称" prop="name">
          <el-input v-model.trim="form.name" placeholder="如：一组、早班组" clearable />
        </el-form-item>
        <el-form-item label="组长" prop="leaderId">
          <el-select v-model="form.leaderId" placeholder="请选择组长" filterable style="width:100%">
            <el-option v-for="s in staffList" :key="s.userId" :value="s.userId" :label="s.realName || s.userName" />
          </el-select>
        </el-form-item>
        <el-form-item label="初始成员">
          <el-select v-model="form.memberIds" multiple filterable placeholder="可多选" style="width:100%">
            <el-option v-for="s in staffList" :key="'m' + s.userId" :value="s.userId" :label="s.realName || s.userName" />
          </el-select>
          <div class="hint">组长将自动加入成员列表</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { addNursingGroup, getAllNursingStaff } from "@/views/care/schedule/scheduleApi";

export default {
  name: "NursingCareGroupForm",
  data() {
    return {
      form: { name: "", leaderId: "", memberIds: [] },
      staffList: [],
      submitting: false,
      rules: {
        name: [{ required: true, message: "请输入组名称", trigger: "blur" }],
        leaderId: [{ required: true, message: "请选择组长", trigger: "change" }]
      }
    };
  },
  mounted() {
    getAllNursingStaff().then(res => {
      if (res && res.code == 200) {
        const data = res.result || res;
        this.staffList = Array.isArray(data) ? data : (data.list || data.records || []);
      }
    });
  },
  methods: {
    reset() {
      this.form = { name: "", leaderId: "", memberIds: [] };
      this.$refs.form && this.$refs.form.clearValidate();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const memberSet = new Set([this.form.leaderId, ...this.form.memberIds]);
        this.submitting = true;
        addNursingGroup({
          name: this.form.name,
          userId: this.form.leaderId,
          userList: [...memberSet].map(id => ({ userid: id }))
        }).then(res => {
          this.submitting = false;
          if (res && res.code == 200) {
            this.$message.success("护理组创建成功");
            this.reset();
          }
        }).catch(() => { this.submitting = false; });
      });
    }
  }
};
</script>
<style scoped>
.page-tip { color: #606266; font-size: 14px; margin-bottom: 20px; }
.hint { font-size: 12px; color: #909399; margin-top: 4px; }
</style>
